import { useEffect } from "react";
import { useQZTray } from "../hooks/useQZTray";

export default function QZTrayInitializer() {
  const { connectToQZTray, isConnected } = useQZTray();

  useEffect(() => {
    connectToQZTray();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Chama apenas uma vez ao montar

  return isConnected ? null : <div>Conectando ao QZ Tray...</div>;
}
